import React from "react";
import FaqCollapsible from "./FaqCollapsible/FaqCollapsible";
const Faq = () => {
  return (
    <div className="section-container flex flex-col items-center" id="faq">
      <h3 className="section-title">FAQ</h3>
      <FaqCollapsible
        ques="What is the CryptoGods: Anubis token?"
        ans="CryptoGods: Anubis is a collection of 10000 randomly generated NFTs
            which welcome the Egyptian God of the Dead into the metaverse.
            CryptoGods: Anubis holders will be a part of the global community
            which gets access to exclusive events, special giveaways and many
            bonuses along the journey."
      />
      <FaqCollapsible
        ques="How can I get a Anubis token?"
        ans="You can mint one from our minting site or if you miss the launch you can find it on opensea."
      />
      <FaqCollapsible
        ques="What is the price of a single Anubis token?"
        ans="80 Matic (Polygon)"
      />
      <FaqCollapsible
        ques="How many tokens can I mint with a single account?"
        ans="The maximum mints from a single account is 10."
      />
      <FaqCollapsible
        ques="What is the utility of the Anubis token?"
        ans="All Anubis holders will get exclusive access to all our events 
             and the early supporters get voting privileges to lead this project to the moon."
      />
      <FaqCollapsible
        ques="What do 'voting privileges' mean?"
        ans="We believe in democracy. The voters will shape the project and its goals. What charity to give to, what to do of the community wallet fund, which metaverse to keep a virtual event in etc. will be decided based upon the majority of the voters."
      />
      <FaqCollapsible
        ques="What is the royalty fee of the Anubis token?"
        ans="10%. Around 8 to 10% of this money would be put in the community wallet and used for events and charities."
      />
      <FaqCollapsible
        ques="When/Where will the community wallet funds be used?"
        ans="These funds will be used to execute all the activities like real life meetups, virtual events, charity work etc. the decision to use these funds will be based on the voting."
      />
    </div>
  );
};
export default Faq;
